import { downloadTemplate } from './excelUtils';

// Column notes:
//   Category / Subcategory — user-definable classification NAMES (not ids). The
//     backend resolves them to existing venue categories/subcategories on import
//     and flags unknown names as warnings in the preview — it does not auto-create
//     them. Subcategory requires a matching Category. Leave blank for none.
//   Selling Price — the inventory item's own default / POS selling price, in
//     human-readable MAJOR currency units (e.g. 95.00). The backend stores it
//     internally in MINOR units (cents) and converts on import/export, so the
//     sheet always shows normal prices. It belongs to the InventoryItem, not to
//     any menu.
//   Menu Name — optional placement column. For a WINE row, it places the item on
//     an existing Menu (the generic Menu container, any type) of that name. It
//     does not set the price. Leave blank (or omit the column) for no placement.
//   Menu Section — optional companion to Menu Name: places the item into that
//     named section of the menu. Matched case-insensitively; a section that
//     doesn't exist yet is created on confirm (the preview announces it).
//     Ignored when Menu Name is blank.
//   Opening Qty / Opening Location — optional first-time stock setup. Opening Qty
//     (a positive number) books the item's starting balance as venue-owned stock
//     at Opening Location (a location name; blank = the venue's default
//     location). Only allowed while the item has no activity at that location —
//     one opening per item+location; re-imports skip it with a warning. Consigned
//     inventory is set up via a consignment receipt, not opening stock.
const INVENTORY_IMPORT_COLUMNS = [
  // Identifiers first. Inventory Item ID is the authoritative Mongo id; Short ID
  // is the human/QR-friendly code. Both are informational on import (matching is
  // unchanged) — they let an exported sheet round-trip with the ids visible.
  { header: 'Inventory Item ID',  example: '665f1c2a9b3e4d0012ab34cd' },
  { header: 'Short ID',           example: 'A1B2C3D4' },
  { header: 'Item Type',          example: 'wine' },
  { header: 'Item Name',          example: 'Château Margaux 2018' },
  { header: 'Category',           example: 'Wine' },
  { header: 'Subcategory',        example: 'Red' },
  { header: 'Size Value',         example: '750' },
  { header: 'Size Unit',          example: 'ml' },
  { header: 'Active',             example: 'true' },
  { header: 'Bin Location',       example: 'A3' },
  { header: 'Par Level',          example: '6' },
  { header: 'Reorder Point',      example: '2' },
  { header: 'Location',           example: 'Main Cellar' },
  { header: 'Supplier Name',      example: 'Berry Bros & Rudd' },
  { header: 'Supplier Item Code', example: 'BBR-12345' },
  { header: 'Cost',               example: '45.00' },
  { header: 'Menu Name',          example: 'Main Menu' },
  { header: 'Menu Section',       example: 'Reds' },
  { header: 'Selling Price',      example: '95.00' },
  { header: 'Lot Tracked',        example: 'FALSE' },
  { header: 'Opening Qty',        example: '12' },
  { header: 'Opening Location',   example: 'Main Cellar' },
];

export const INVENTORY_IMPORT_HEADERS = INVENTORY_IMPORT_COLUMNS.map(c => c.header);

export function downloadInventoryImportTemplate(): void {
  downloadTemplate('inventory-import', INVENTORY_IMPORT_COLUMNS);
}
